if (!customElements.get("video-snippet")) {
  class VideoComponent extends HTMLElement {
    handleResize = () => {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.checkVideo();
      }, 200);
    };

    connectedCallback() {
      this.timeout ??= null;
      this.currentSrc ??= null;

      this.video = this.querySelector("iframe, video");
      if (!this.video || this.closest(".video-carousel")) return;

      this.checkVideo();
      window.addEventListener("resize", this.handleResize);
    }

    disconnectedCallback() {
      clearTimeout(this.timeout);
      window.removeEventListener("resize", this.handleResize);
    }

    checkVideo() {
      const isMobile = window.matchMedia(
        `(max-width: ${window.themeBreakpoints[this.dataset.breakMobile]}px)`,
      ).matches;

      const src = this.video.dataset.mediaSrc;
      const mobileSrc =
        "mediaSrcMobile" in this.video.dataset
          ? this.video.dataset.mediaSrcMobile
          : src;
      const newSrc = isMobile ? mobileSrc : src;

      // Compare against the last value we set: `this.video.src` reflects the
      // resolved absolute URL, so it never matched the raw data attribute and
      // the source was reassigned (and the video restarted) on every resize.
      if (newSrc !== this.currentSrc) {
        this.currentSrc = newSrc;
        this.video.src = newSrc;
      }

      this.dataset.fillDirection = isMobile
        ? this.dataset.fillDirectionMobile
        : this.dataset.fillDirectionDesktop;
    }
  }

  customElements.define("video-snippet", VideoComponent);
}
